export default {
    serverUrl: 'https://docverify.co/api/v1',
    serverFolder: 'demo',
    configFilename: 'config.docread.json'
}
